/* eslint-disable
    import/no-unresolved,
*/
// TODO: This file was created by bulk-decaffeinate.
// Fix any style issues and re-enable lint.
/*
 * decaffeinate suggestions:
 * DS102: Remove unnecessary code created because of implicit returns
 * Full docs: https://github.com/decaffeinate/decaffeinate/blob/master/docs/suggestions.md
 */
require('./conversationBrief.scss');

const deps = [];

module.exports = angular
  .module('bench.ui.conversationBrief', deps)

  .directive('blWebConversationBrief', () => ({
    restrict: 'E',
    scope: {
      id: '=conversationId',
    },
    bindToController: true,
    template: require('./conversationBrief.html'),
    controller: require('./conversationBriefCtrl.js'),
    controllerAs: 'vm',
  }));
